interface Notice {
  key: string;
  noticeType: 'warn' | 'info';
}

interface RowData {
  key: string;
  type: 'row' | 'category' | 'summary';
  background?: boolean;
}

export const rows: RowData[] = [
  { key: 'accountManagement', type: 'row' },
  { key: 'availableFunds', type: 'category' },
  { key: 'numberOfFunds', type: 'row', background: true },
  { key: 'numberOfFundsSavingPlan', type: 'row' },
  { key: 'fundConditions', type: 'category' },
  { key: 'fundPurchasePrice', type: 'row', background: true },
  { key: 'fundSavingsPlanPrice', type: 'row' },
  { key: 'commissionReimbursement', type: 'category' },
  { key: 'averageReimbursement', type: 'row', background: true },
  { key: 'ETFConditions', type: 'category' },
  { key: 'ETFPurchasePrice', type: 'row', background: true },
  { key: 'ETFSavingsPlanPrice', type: 'row' },
  { key: 'stockExchangeTransactions', type: 'category' },
  { key: 'exchangeTrading', type: 'row', background: true },
  { key: 'securitiesTrading', type: 'row' },
  { key: 'drawings', type: 'row', background: true },
  { key: 'capitalAccumulationBenefits', type: 'category' },
  { key: 'VLSavingsPlan', type: 'row', background: true },
  { key: 'others', type: 'category' },
  { key: 'service', type: 'row', background: true },
  { key: 'reachability', type: 'row' },
  { key: 'tel', type: 'row', background: true },
  { key: 'onlineBanking', type: 'row' },
  { key: 'financeManager', type: 'row', background: true },
  { key: 'rating', type: 'summary' },
];

export const notices: Record<string, Notice[]> = {
  comdirect: [
    { key: 'fundPurchasePrice', noticeType: 'info' },
    { key: 'securitiesTrading', noticeType: 'info' },
    { key: 'drawings', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
  ],
  dab: [
    { key: 'fundPurchasePrice', noticeType: 'info' },
    { key: 'fundSavingsPlanPrice', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
    { key: 'securitiesTrading', noticeType: 'info' },
    { key: 'ETFPurchasePrice', noticeType: 'info' },
  ],
  ebase: [
    { key: 'accountManagement', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
  ],

  fondsdepotbank: [
    { key: 'accountManagement', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
  ],
  ffb: [
    { key: 'accountManagement', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
  ],
  morgenfund: [
    { key: 'accountManagement', noticeType: 'info' },
    { key: 'financeManager', noticeType: 'info' },
  ],
};

export const ratings: Record<string, number> = {
  comdirect: 5,
  dab: 3,
  ebase: 3,
  fondsdepotbank: 4,
  ffb: 2,
  morgenfund: 2,
};
